export default "__VITE_ASSET__BPStZuEq__"